/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * CategoryForm.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {CategoryDTO} from "../../dto/category/CategoryDTO";

export default class CategoryForm extends AbstractForm<CategoryDTO> {

    constructor(dto?: CategoryDTO) {
        super();

        this.fields.set(CategoryDTO.TITLE, new TextField(
            CategoryDTO.TITLE,
            (t: Translation) => t.categoryListColTitle,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));
        this.fields.set(CategoryDTO.ORDER, new TextField(
            CategoryDTO.ORDER,
            (t: Translation) => t.positionHint,
            value => {
                let numberValue = Number(value.toString());
                return !isNaN(numberValue) && numberValue >= 0;
            },
            Type.NUMBER,
            true,
            "",
            "0"
        ));

        if (dto) super.load(dto);
    }
}
